/*
sites-api.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('sitesApi',['angular', 'urlBuilder', 'markupEncoder'], function () {

// Module Dependencies
    var dependencies = [
        'Services.UrlBuilder', 'Services.MarkupEncoder'
    ];

    // Module Definition
    var mod = angular.module('Services.SitesApi', dependencies);

    /**
     * @name sitesApi
     * @type factory
     *
     * @description
     * A factory that provides methods for making requests to the Site Management REST API.
     */
    mod.factory('sitesApi', ['$q', '$log', 'urlBuilder', 'markupEncoderService', '$http', function ($q, $log, urlBuilder, markupEncoderService, $http) {
        /**
         * Base url for requests to the Site Management REST API.
         */
        var SITES_URL = '/v1/umgmt/sites';
        var ALL_SITES_URL = '/getSelfRegSites';
        var ORGANIZATION_URL = '/getOrganizations';
        var USER_ORGANIZATION_URL = '/v1/umgmt/getUserOrganization';
        var SET_USER_ORGANIZATION = '/setUserOrganization';

        // for storing a copy of the sites response from getSites()
        // used for parsing the organization-site mapping
        var sitesData;

        /**
         * Public API
         */
        return {
            // GET
            getAllSite: getAllSite,
            getSite: getSite,
            getOrganizations: getOrganizations,
            getUserOrganization: getUserOrganization,
            getSites: getSites,
            getSitesById: getSitesById,
            setUserOrganization: setUserOrganization,
            // POST
            createSite: createSite,
            createDepartment: createDepartment,
            // PATCH
            patchSite: patchSite,
            getOrganizationSiteMapping: getOrganizationSiteMapping
        };

        /**
         * Gets a site by ID from the server.
         *
         * @param id
         *    The ID of the site to retrieve.
         *
         * @param options.fields
         *    Limit the response to providing only the specified fields. This option may be
         *    either an array of field names or a comma-separated string of field names.
         *
         * @param options.excludeFields
         *    Exclude the specified fields from the response. This option may be either
         *    an array of field names or a comma-separated string of field names.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function getSite(id, options, settings) {
            // Validate arguments
            if (angular.isString(id) === false && angular.isNumber(id) === false) {
                var errorMsg = 'Error: sitesApi: getSite: invalid parameter: id = ' + id;
                $log.error(errorMsg);
                return $q.reject(errorMsg);
            }

            var deferred = $q.defer(),
                options = options || {}, /* NOSONAR */
                settings = settings || {}, /* NOSONAR */
                url = urlBuilder.buildUrl(SITES_URL + '/' + id, options);

            // Send the request
            $.ajax({
                async: (settings.async === false) ? false : true,
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: sitesApi: GET "' + url + '"');
                var site = data || null;
                deferred.resolve(site);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: sitesApi: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }

        }

        /**
         * Gets all the organization from the server.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function getOrganizations() {
            var deferred = $q.defer(),
                url = ORGANIZATION_URL;

            // Send the request
            $.ajax({
                async: false,
                contentType: 'application/json',
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: sitesApi: GET "' + url + '"');
                var organization = data || null;
                deferred.resolve(organization);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: sitesApi: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }

        }

        /**
         * Gets organization to which user belongs to from the server.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function getUserOrganization() {
            var deferred = $q.defer(),
                url = USER_ORGANIZATION_URL;

            // Send the request
            $.ajax({
                async: false,
                cache: false,
                contentType: 'application/json',
                dataType: 'json',
                type: 'get',
                url: url,
                headers: {"Authorization": "Bearer " + sessionStorage.getItem('cIdToken')},
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: sitesApi: GET "' + url + '"');
                var organization = data || null;
                deferred.resolve(organization);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: sitesApi: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorThrown);
            }

        }

        /**
         * Sets organization to which user opts for to from the server.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */

        function setUserOrganization(orgID) {
            var deferred = $q.defer(),
                url = SET_USER_ORGANIZATION + '/' + orgID;

            // Send the request
            $http.post(url, undefined, {
                headers: {"Authorization": "Bearer " + sessionStorage.getItem('cIdToken')}
            })
                .then(function (data) {
                    deferred.resolve(data);
                }, function (data) {
                    deferred.reject(data);
                });

            return deferred.promise;
        }

        /**
         * Gets an array of all the sites from the server.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function getAllSite() {
            var deferred = $q.defer(),
                url = ALL_SITES_URL;

            // Send the request
            $.ajax({
                async: true,
                contentType: 'application/json',
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: sitesApi: GET "' + url + '"');
                var site = data || null;
                deferred.resolve(site);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: sitesApi: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }

        }

        //***************************************************************************************************

        /**
         * Gets an array of sites from the server.
         *
         * @param options.status
         *    The status of the sites to return (e.g. 'active' or 'pending').
         *
         * @param options.offset
         *    The offset of the first site to return (default is 0).
         *
         * @param options.limit
         *    The maximum number of sites to return (default is 50).
         *
         * @param options.legalName
         *    The legal name of the site to return.
         *
         * @param options.nickName
         *    The nickname of the site to return.
         *
         * @param options.roles
         *    Limits the response to sites for which the current user fills the specified role(s).
         *
         * @param options.fields
         *    Limit the response to providing only the specified fields. This option may be
         *    either an array of field names or a comma-separated string of field names.
         *
         * @param options.excludeFields
         *    Exclude the specified fields from the response. This option may be either
         *    an array of field names or a comma-separated string of field names.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function getSites(options, settings) {
            var deferred = $q.defer(),
                options = options || {}, /* NOSONAR */
                settings = settings || {}, /* NOSONAR */
                url = urlBuilder.buildUrl(SITES_URL, options);

            // Send the request
            $.ajax({
                async: (settings.async === false) ? false : true,
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: sitesApi: GET "' + url + '"');
                var sites = data || [];
                sitesData = sites.data;
                deferred.resolve(angular.copy(sites));
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: sitesApi: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }

        }

        /**
         * Gets multiple sites by ID from the server.
         *
         * @param ids
         *    An array of site IDs (one for each site to retrieve).
         *
         * @param options.fields
         *    Limit the response to providing only the specified fields. This option may be
         *    either an array of field names or a comma-separated string of field names.
         *
         * @param options.excludeFields
         *    Exclude the specified fields from the response. This option may be either
         *    an array of field names or a comma-separated string of field names.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @note
         *    Presently, the '/sites' API does not allow us to get multiple sites by providing the
         *    IDs of all the sites we'd like to retrieve. Until the '/sites' API is extended to
         *    provide this functionality, we must use this helper function (which strings together
         *    multiple requests to the '/sites/:id' API) to emulate the desired functionality.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function getSitesById(ids, options, settings) {
            // Validate arguments
            if (angular.isArray(ids) === false) {
                var errorMsg = 'Error: sitesApi: getSitesById: invalid parameter: ids = ' + ids;
                $log.error(errorMsg);
                return $q.reject(errorMsg);
            }

            var deferred = $q.defer(),
                options = options || {}, /* NOSONAR */
                settings = settings || {}, /* NOSONAR */
                promises = [];

            // Send the requests
            for (var i = 0, iEnd = ids.length; i < iEnd; i++) {
                promises.push(getSite(ids[i], options, settings));
            }

            // Wait for all of the requests to complete
            $q.all(promises).then(
                function (sites) {
                    deferred.resolve(sites);
                },
                function (reason) {
                    deferred.reject(reason);
                });

            return deferred.promise;
        }

        /**
         * Create a new site with the provided data.
         *
         * @param data
         *    Site data to be sent with the site creation request.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function createSite(data, settings) {
            // Validate arguments
            if (angular.isObject(data) === false) {
                var errorMsg = 'Error: sitesApi: createSite: invalid parameter: data = ' + data;
                $log.error(errorMsg);
                return $q.reject(errorMsg);
            }

            var deferred = $q.defer(),
                settings = settings || {}; /* NOSONAR */

            // encode HTML in string content in data object
            // (essentially, replace '<' and '>' with '&lt;' and '&gt;', respectively )
            markupEncoderService.encodeMarkup(data);
// Send the request
            $.ajax({
                async: (settings.async === false) ? false : true,
                contentType: 'application/json',
                type: 'post',
                url: SITES_URL,
                data: JSON.stringify(data),
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: sitesApi: createSite');
                var siteUrl = data || null;
                deferred.resolve(siteUrl);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var createSiteErrorMsg = 'Error: sitesApi: createSite: ' + errorThrown;
                $log.error(createSiteErrorMsg);
                deferred.reject(createSiteErrorMsg);
            }

        }

        /**
         * Patches an existing site with the specified id using the provided data.
         *
         * @param id
         *    Id of the site to patch.
         *
         * @param data
         *    An array of PATCH operations.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function patchSite(id, data, settings) {
            if (angular.isString(id) === false && angular.isNumber(id) === false) {
                var invalidParameterIdErrorMsg = 'Error: sitesApi: patchSite: invalid parameter: id = ' + id;
                $log.error(invalidParameterIdErrorMsg);
                return $q.reject(invalidParameterIdErrorMsg);
            }
            // Validate arguments
            if (angular.isArray(data) === false) {
                var invalidParameterDataErrorMsg = 'Error: sitesApi: patchSite: invalid parameter: data = ' + data;
                $log.error(invalidParameterDataErrorMsg);
                return $q.reject(invalidParameterDataErrorMsg);
            }

            var deferred = $q.defer(),
                settings = settings || {}, /* NOSONAR */
                url = SITES_URL + '/' + id;

            // encode HTML in string content in data object
            // (essentially, replace '<' and '>' with '&lt;' and '&gt;', respectively )
            markupEncoderService.encodeMarkup(data);

            // Send the request
            $.ajax({
                async: (settings.async === false) ? false : true,
                contentType: 'application/json; charset=utf-8',
                type: 'patch',
                url: url,
                data: JSON.stringify(data),
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: sitesApi: patchSite');
                var site = data || null;
                deferred.resolve(site);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: sitesApi: patchSite: ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }

        }

        /**
         * Create a new department with the provided data.
         *
         * @param data
         *    Department data to be sent with the department creation request.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function createDepartment(id, data, settings) {
            // Validate arguments
            if (angular.isObject(data) === false) {
                var errorMsg = 'Error: sitesApi: createDepartment: invalid parameter: data = ' + data;
                $log.error(errorMsg);
                return $q.reject(errorMsg);
            }

            var deferred = $q.defer(),
                settings = settings || {}, /* NOSONAR */
                url = SITES_URL + '/' + id + '/departments';

            // encode HTML in string content in data object
            // (essentially, replace '<' and '>' with '&lt;' and '&gt;', respectively )
            markupEncoderService.encodeMarkup(data);

            // Send the request
            $.ajax({
                async: (settings.async === false) ? false : true,
                contentType: 'application/json',
                type: 'post',
                url: url,
                data: JSON.stringify(data),
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                $log.log('Success: sitesApi: createDepartment');
                var departmentUrl = data || null;
                deferred.resolve(departmentUrl);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: sitesApi: createDepartment: ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }

        }

        /**
         * Returns an organization-sites mapping from sites data fetched
         * by the last call to getSites()
         *
         */

        function getOrganizationSiteMapping() {
            if (typeof sitesData === 'undefined' || (!sitesData instanceof Array)) {
                return null;
            }
            var orgSites = {}, orgSitesArray = [];
            // Use the array map() function to iterate through the sitesData array;
            sitesData.map(function (siteObj) {
                var org = siteObj['organization'];
                // if current org is a valid organization with an 'id' attrubute
                if (org && org.id) {
                    // get string version of org.id
                    var orgIdStr = org.id + '';
                    // copy and store current org if needed
                    if (!orgSites[orgIdStr]) {
                        orgSites[orgIdStr] = angular.copy(org);
                    }
                    // create a sites array in current org if needed
                    if (!orgSites[orgIdStr].sites || (!orgSites[orgIdStr] instanceof Array)) {
                        orgSites[orgIdStr].sites = [];
                    }
                    // push site object in current org
                    orgSites[orgIdStr].sites.push(siteObj);
                }
            });
            // derive org-sites array from org-sites object;
            for (var prop in orgSites) {
                if (orgSites.hasOwnProperty(prop)) {
                    orgSitesArray.push(orgSites[prop]);
                }
            }
            // return mapping array for organizations and sites;
            return orgSitesArray;
        }
    }]);

});

